import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=0e7a4649&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=0e7a4649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a4649",
  null
  
)

export default component.exports